import { render, staticRenderFns } from "./PageTable.vue?vue&type=template&id=52857fb8"
import script from "./PageTable.vue?vue&type=script&lang=js"
export * from "./PageTable.vue?vue&type=script&lang=js"
import style0 from "./PageTable.vue?vue&type=style&index=0&id=52857fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports